import { render } from "./CheckDetails.vue?vue&type=template&id=06a7f75c&scoped=true"
import script from "./CheckDetails.vue?vue&type=script&lang=js"
export * from "./CheckDetails.vue?vue&type=script&lang=js"

import "./CheckDetails.vue?vue&type=style&index=0&id=06a7f75c&lang=less&scoped=true"
import "./CheckDetails.vue?vue&type=style&index=1&id=06a7f75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a7f75c"]])

export default __exports__